import React from 'react';
import { connect } from 'react-redux';
import Form from '../../FormsTemplate';
import { FormNames } from '../../Forms.constants';
import UserInfoSection from '../../Sections/UserInfoSection/UserInfoSection';
import ManufacturerModelSection from '../../Sections/ManufacturerModelSection/ManufacturerModelSection';
import DeviceTypesSection from '../../Sections/DeviceTypesSection/DeviceTypesSection';
import HMISection from '../../Sections/HMISection/HMISection';
import VisualInspectSection from '../../Sections/VisualInspectSection/VisualInspectSection';
import NoteSection from '../../Sections/NoteSection/NoteSection';
import AsFoundTestTableSection from '../../Sections/AsFoundTestTableSection/AsFoundTestTableSection';
import FoundResultSection from '../../Sections/FoundResultSection/FoundResultSection';
import AsLeftTestTableSection from '../../Sections/AsLeftTestTableSection/AsLeftTestTableSection';
import TestResultSection from '../../Sections/TestResultSection/TestResultSection';
import BorderedBox from '../../BorderedBox';
import ToleranceInstrumentEUComment from '../../Sections/ToleranceInstrumentEUComment/ToleranceInstrumentEUComment';
import TestResultComponent from '../../Sections/TestResultComponent/TestResultComponent';
import FlowChangeCheckSection from '../../Sections/FlowChangeCheck/FlowChangeCheckSection';

const P642Form = (props) => (
    <Form
        formName={FormNames.P642}
    >
        <UserInfoSection />
        <ManufacturerModelSection />
        <DeviceTypesSection />
        <HMISection />
        <VisualInspectSection />
        <BorderedBox>
            <FlowChangeCheckSection />
        </BorderedBox>
        <BorderedBox>
            <AsFoundTestTableSection />
            <FoundResultSection />
        </BorderedBox>
        <ToleranceInstrumentEUComment />
        <BorderedBox>
            <AsLeftTestTableSection />
        </BorderedBox>
        <TestResultSection />
        <TestResultComponent />
        <NoteSection />
    </Form>
);

const mapStateToProps = ({ Forms }) => ({
    selectedTag: Forms.selectedTag,
});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P642Form);
